import { Expose } from 'class-transformer'

export class PDPAConsentType {
  @Expose()
  termsOfUse: string

  @Expose()
  privacyPolicy: string
}
